const UNITS = [ { id: 'g', name: 'g (grams)' }, { id: 'kg', name: 'kg (kilograms)' }, { id: 'cl', name: 'cl (centiliters)' }, { id: 'l', name: 'l (liters)' } ]

export default {
  UNITS
}



// WEBPACK FOOTER //
// ./src/constants.js